import Swiper, { Navigation } from "swiper";

export const initialiseLatestOffersSlider = () => {
    const offersSlices = document.querySelectorAll('.cms-content-slice-latest-offers');
    const offersSliceLength = offersSlices.length;

    if (offersSliceLength <= 0) {
        return;
    }

    for (let index = 0; index <  offersSliceLength; index++) {
        const slider = offersSlices[index].querySelector('.offer-card__swiper');
        const slidesCount = slider.querySelectorAll('.swiper-slide').length;

        if (slider) {
            new Swiper(slider, {
                modules: [Navigation],
                grabCursor: true,
                slidesPerView: Math.min(slidesCount, 1),
                spaceBetween: 30,
                rewind: true,
                navigation: {
                    nextEl: '.swiper-offer__slider-nav--next',
                    prevEl: '.swiper-offer__slider-nav--prev',
                },
                breakpoints: {
                    576: {
                        slidesPerView: Math.min(slidesCount, 2),
                    },
                    768: {
                        slidesPerView: Math.min(slidesCount, 3),
                    },
                }
            });
        }
    }
}
